import React from 'react';
import './PerformanceIndicators.css';

const PerformanceIndicators = () => {
  const kpis = [
    {
      label: 'Order Fulfillment Rate',
      value: '96%',
      sublabel: 'Orders completed successfully',
      color: '#2D6A4F',
      progress: 96
    },
    {
      label: 'Average Preparation Time',
      value: '28 mins',
      sublabel: 'Avg cooking time',
      target: '30 mins',
      color: '#004E89',
      onTarget: true
    },
    {
      label: 'Cancellation Rate',
      value: '4%',
      sublabel: 'Orders cancelled',
      trend: '-2%',
      color: '#D62828',
      improvement: true
    },
    {
      label: 'Response Time',
      value: '2.5 mins',
      sublabel: 'Avg order acceptance time',
      color: '#004E89'
    }
  ];

  return (
    <div className="performance-indicators-card">
      <div className="kpi-grid">
        {kpis.map((kpi, i) => (
          <div key={i} className="kpi-item">
            <div className="kpi-value" style={{ color: kpi.color }}>
              {kpi.value}
            </div>
            <div className="kpi-label">{kpi.label}</div>
            <div className="kpi-sublabel">{kpi.sublabel}</div>
            
            {kpi.progress && (
              <div className="kpi-progress-ring">
                <svg viewBox="0 0 80 80" className="kpi-ring-svg">
                  <circle
                    cx="40"
                    cy="40"
                    r="32"
                    fill="none"
                    stroke="#E9ECEF"
                    strokeWidth="4"
                  />
                  <circle
                    cx="40"
                    cy="40"
                    r="32"
                    fill="none"
                    stroke={kpi.color}
                    strokeWidth="4"
                    strokeDasharray={`${2 * Math.PI * 32}`}
                    strokeDashoffset={`${2 * Math.PI * 32 * (1 - kpi.progress / 100)}`}
                    strokeLinecap="round"
                    transform="rotate(-90 40 40)"
                  />
                </svg>
              </div>
            )}

            {kpi.target && (
              <div className={`kpi-target ${kpi.onTarget ? 'on-target' : 'off-target'}`}>
                Target: {kpi.target}
              </div>
            )}

            {kpi.trend && (
              <div className={`kpi-trend ${kpi.improvement ? 'positive' : 'negative'}`}>
                <span>{kpi.improvement ? '↓' : '↑'}</span> {kpi.trend}
              </div>
            )}

            {kpi.stars && (
              <div className="kpi-stars">
                {'⭐'.repeat(Math.floor(parseFloat(kpi.value)))}
                {'☆'.repeat(kpi.stars - Math.floor(parseFloat(kpi.value)))}
              </div>
            )}
          </div>
        ))}
      </div>
    </div>
  );
};

export default PerformanceIndicators;

